import $ from 'jquery'
import async from 'async'
import util from 'util'
import _ from 'lodash'

let _p = window.xwCommon,
  _this = {
    	title:"待办任务",
    	name:"car_user_todo",
    	readList(vm,p,s){
    		vm.loading = true;
	        let url = _p.getApiUrl("ordernode/todo"),
	            page = p || vm.currentPage, page_size = s || vm.pageSize,product_type=1
	            if(vm.isHomePageSub){product_type = -1}else{product_type=1}
	        $.post(url,{ page, page_size,back_state:2 ,product_type},(json) => _this.fillData(vm, json))
	    },
    	fillData(vm, json){
	        //console.log(arguments)
	        let status = parseInt(json.status)
	        if(200 !== status){
	          switch(status){
	            default: 
	              if(_p.checkAjaxStatus(vm,json,_this.title)) break;
	            //   vm.$alert(json.msg,_this.title);
	              break;
	          }
	          return;
	        } else if(_p.isNull(json.data)){
	        	vm.$nextTick(() => {
	        		vm.tableData = []
	            	vm.currentPage = 1
	            	vm.totalRow = 0
	            	vm.pageSize = 20
					vm.loading = false
					vm.$emit("getTotal",vm.totalRow)
	        	})
	        }else {
	          vm.$nextTick(() => {
                let tableData =json.data.data|| [];
	          	if(tableData.length>0){
	          		for(let key in tableData){ 
	                     if(tableData[key].product_type==1){
	                        tableData[key].product_type="车贷" 
	                     }else if(tableData[key].product_type==2){
	                        tableData[key].product_type="普惠"
	                     }
	                 }
	          	}

	            vm.tableData = tableData
	            vm.currentPage = parseInt(json.data.current_page)
	            vm.totalRow = parseInt(json.data.total)
	            vm.pageSize = parseInt(json.data.per_page)
			        vm.loading = false,
							vm.$emit("getTotal",vm.totalRow)
	          })
	          
	        }
      	},
      	showChoiceWin(vm,order_node_id){
      		async.waterfall([
				( next ) => {
					_this.getChoiceStaff(order_node_id).then((data) => {
						vm.staffChoiceList = data.map((o) => {return {
							"name":util.format("%s - %s(待办任务 %s 件)",o.username,o.role_name,o.backlog),
							"staff_id":o.staff_id
						}})
						next(null)
					})
				},
				( next ) => {
					vm.choiceDialog["order_node_id"] = order_node_id
					vm.choiceDialog["staff_id"] = null
					vm.choiceDialog.visible = true
					next(null)
				}
			],(err) => {
            	if(err) {
            		vm.$alert(err.toString(),_this.title);
            	}
            })
      	},
      	getChoiceStaff(order_node_id){
      		let u = _p.getApiUrl("staff/distributing"),func = ( callback, reject ) => {
				$.post(u,{order_node_id},(json) => {
		          let status = parseInt(json.status)
		          	if(200 !== status){
		            	switch(status){
		                    default: 
		                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
		                      //vm.$alert(json.msg,_this.title);
		                      reject(json)
		                      break;
		                }
		                return;
		          	}else{
			            callback(json.data)
			        }
		        },"JSON")
			}

			return new Promise(func)
      	},
      	submitChoice(vm,order_node_id,staff_id){
      		vm.loading = true;
	        let u = _p.getApiUrl("ordernode/assign")

	        $.post(u,{order_node_id, staff_id},(json) => {
	        	let status = parseInt(json.status)
	          	if(200 !== status){
	            	switch(status){
	            		case 1002:
			                json.data.forEach((desc)=>{
			                  //console.log(desc)
			                  vm.$set(vm.customerBasicError, desc.name, desc.error)
			                })
			                break;
	                    default: 
		                    if(_p.checkAjaxStatus(vm,json,_this.title)) break;
		                    vm.$alert(json.msg,_this.title);
		                    break;
	                }
	                return;
	          	}else{
		            vm.$notify({title:_this.title,message:json.msg});
		            vm.choiceDialog.visible = false
            		_this.readList(vm)
		        }
	        },"JSON")
      	}
    }


export default _this


// WEBPACK FOOTER //
// ./src/lib/car/task/refundOrder.js